/**
 * ListaPrecoLocalRepository
 *
 * Abstrai o acesso às listas de preço armazenadas localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const ListaPrecoLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async listar() {
    return this._api().listaPreco.listar();
  },

  async salvar(listas) {
    return this._api().listaPreco.salvar(listas);
  },

  /**
   * Retorna os registros de lista_produtos_local para um produto,
   * com o preco_lista de cada lista que o contém.
   * @param {number} id_produto
   * @returns {Promise<Array<{ id_lista_preco, preco_lista, descricao_lista }>>}
   */
  async buscarPorProduto(id_produto) {
    return this._api().listaPreco.buscarPorProduto(id_produto);
  },

  /**
   * Dado um id_lista_preco e um id_produto, retorna o preco_lista ou null.
   * @param {number} id_lista_preco
   * @param {number} id_produto
   * @returns {Promise<number|null>}
   */
  async precoParaProduto(id_lista_preco, id_produto) {
    const rows = await this.buscarPorProduto(id_produto);
    const row = (rows || []).find((r) => r.id_lista_preco === id_lista_preco);
    return row ? Number(row.preco_lista) : null;
  },
};

export default ListaPrecoLocalRepository;
